import React, { useState } from 'react';
import { InputBase, IconButton } from '@mui/material';
import { Search as SearchIcon } from 'lucide-mui';
import { styled } from '@mui/material/styles';
import { useQuery, useUpdateQuery } from '../../../hooks/urlHooks';

const SearchWrapper = styled('form')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '240px',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  border: `1px solid ${theme.palette.secondary.light}`,
  '&:focus-within': {
    borderColor: theme.palette.secondary.main,
  },
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(0.75, 0.5, 0.75, 1.25),
    fontSize: '0.875rem',
    width: '100%',
    color: theme.palette.text.primary,
    '&::placeholder': {
      opacity: 0.7,
    },
  },
}));

const Searchbar = () => {
  const { searchQuery: initialQuery } = useQuery();
  const updateQuery = useUpdateQuery();
  const [searchQuery, setSearchQuery] = useState(initialQuery);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    updateQuery({
      searchQuery,
    });
  };

  return (
    <SearchWrapper onSubmit={handleSearch}>
      <StyledInputBase
        placeholder="Search…"
        inputProps={{ 'aria-label': 'search' }}
        value={searchQuery}
        onChange={handleInputChange}
      />
      <IconButton
        type="submit"
        sx={{
          p: '4px',
          mr: '2px',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
        aria-label="search"
      >
        <SearchIcon fontSize="small" />
      </IconButton>
    </SearchWrapper>
  );
};

export default Searchbar;
